import Game from "./Game"
import { eventGames, viewport } from "@/constants"
import { FolderOpenIcon } from "@heroicons/react/24/outline"
import { motion } from "framer-motion"

const getExtraY = (index: number) => {
  if (index === 0) return 120
  if (index === 1) return 60
  return 0
}

const variants = {
  hidden: (index: number) => ({
    scale: 0.9,
    y: 90 + getExtraY(index),
  }),
  exit: (index: number) => ({
    scale: 0.9,
    y: 90 + getExtraY(index),
  }),
  show: (index: number) => ({
    scale: 1,
    y: 0,
    transition: {
      delay: 0.2 * index,
      type: "spring" as const,
      bounce: 0.1,
    },
  }),
}

const Events = () => (
  <div className="relative h-[310px] w-full max-w-[466px] select-none lg:max-w-none">
    {eventGames.map((game, index) => (
      <motion.div
        key={game.players}
        custom={index}
        variants={variants}
        initial="hidden"
        whileInView="show"
        exit="exit"
        className="relative z-10"
        viewport={viewport}
      >
        <div className="py-1">
          <Game key={game.players} {...game} />
        </div>
      </motion.div>
    ))}

    <div className="bg-chessdrop-600 absolute inset-x-0 bottom-0 overflow-hidden rounded-2xl pt-4 shadow-lg">
      <div className="bg-chessdrop-500 relative z-10 flex w-full items-center justify-center rounded-2xl px-6 py-14 drop-shadow-[0_0_15px_rgba(0,0,0,0.25)]">
        <div className="absolute bottom-4 left-4 flex items-center space-x-2 font-medium text-white">
          <FolderOpenIcon className="h-6 w-6 text-white/60" />
          <span>Candidates Tournament</span>
        </div>
      </div>
    </div>
  </div>
)

export default Events
